/* EMA merchandising v1: consented browser assistance; no collection reordering. */
(function (factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (typeof window !== 'undefined' && typeof document !== 'undefined') api.boot(window, document);
})(function () {
  'use strict';
  var VERSION = 'ema-merchandising-v1';
  var STORAGE_KEY = 'ema_merchandising_v1';
  var VISIT_GAP = 30 * 60 * 1000;
  var DAY = 86400000;
  var MAX_ITEMS = 20;
  var LEGACY_KEYS = ['ema_behavior', 'ema_variants', 'aquaconvert_session'];
  function validHandle(value) { return typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,150}$/.test(value); }
  function id(value) { return /^\d+$/.test(String(value || '')) ? String(value) : null; }
  function windowDays(type) {
    /* Only explicit product types select a window. Unknown types use 14 days. */
    return /^(equipment|aquarium|aquariums|pump|pumps|lighting|filtration|skimmer|skimmers)$/i.test(type || '') ? 30 : 14;
  }
  function empty(scope) { return { version: VERSION, scope: scope, visit: null, items: {} }; }
  function safeRemove(storage, key) { try { storage.removeItem(key); } catch (_) {} }
  function createStore(storage, scope, allowed, clock, newId) {
    var memory = empty(scope);
    function clear() {
      safeRemove(storage, STORAGE_KEY);
      LEGACY_KEYS.forEach(function (key) { safeRemove(storage, key); });
      memory = empty(scope);
    }
    function clean(raw) {
      if (!raw || raw.version !== VERSION || raw.scope !== scope) return empty(scope);
      var now = clock();
      var next = empty(scope);
      if (raw.visit && typeof raw.visit.id === 'string' && raw.visit.id.length < 100 && Number.isFinite(raw.visit.lastActive) && raw.visit.lastActive <= now && now - raw.visit.lastActive < VISIT_GAP) {
        next.visit = { id: raw.visit.id, lastActive: raw.visit.lastActive };
        if (raw.visit.choiceChecked === true) next.visit.choiceChecked = true;
        if (validHandle(raw.visit.choice)) next.visit.choice = raw.visit.choice;
      }
      Object.keys(raw.items || {}).filter(validHandle).sort(function (a, b) {
        return Number(raw.items[b] && raw.items[b].lastViewed || 0) - Number(raw.items[a] && raw.items[a].lastViewed || 0);
      }).slice(0, MAX_ITEMS).forEach(function (handle) {
        var item = raw.items[handle];
        if (!item || !Number.isFinite(item.lastViewed) || item.lastViewed > now || now - item.lastViewed > 30 * DAY) return;
        var visits = Array.isArray(item.visits) ? item.visits : [];
        var days = item.days === 30 ? 30 : 14;
        visits = visits.filter(function (v) { return v && typeof v.id === 'string' && v.id.length < 100 && Number.isFinite(v.at) && v.at <= now && now - v.at <= days * DAY; }).slice(-10);
        next.items[handle] = { productId: id(item.productId), variantId: id(item.variantId), days: days, lastViewed: item.lastViewed, visits: visits };
      });
      return next;
    }
    function read() {
      if (!allowed()) { clear(); return empty(scope); }
      try { memory = clean(JSON.parse(storage.getItem(STORAGE_KEY))); } catch (_) { memory = clean(memory); }
      return memory;
    }
    function write(data) {
      if (!allowed()) { clear(); return; }
      memory = clean(data);
      try { storage.setItem(STORAGE_KEY, JSON.stringify(memory)); } catch (_) {}
    }
    function visit(data) {
      var now = clock();
      if (!data.visit || now - data.visit.lastActive >= VISIT_GAP) data.visit = { id: newId(), lastActive: now };
      data.visit.lastActive = now;
      return data.visit;
    }
    function currentVisit() { if (!allowed()) return null; var data = read(); var v = visit(data); write(data); return v.id; }
    function view(product) {
      if (!allowed() || !product || !validHandle(product.handle)) return;
      var data = read(); var v = visit(data); var now = clock();
      var item = data.items[product.handle] || { visits: [] };
      if (!item.visits.some(function (entry) { return entry.id === v.id; })) item.visits.push({ id: v.id, at: now });
      item.productId = id(product.id); item.variantId = id(product.variantId); item.days = windowDays(product.type); item.lastViewed = now;
      data.items[product.handle] = item; write(data);
    }
    function selectVariant(product, variantId) {
      if (!allowed() || !product || !validHandle(product.handle)) return;
      var data = read(); if (!data.items[product.handle]) return;
      data.items[product.handle].variantId = id(variantId); write(data);
    }
    function candidate() {
      if (!allowed()) return null;
      var data = read(); var v = visit(data);
      if (!v.choiceChecked) {
        v.choiceChecked = true;
        var handles = Object.keys(data.items).filter(function (handle) {
          var item = data.items[handle];
          return new Set(item.visits.map(function (entry) { return entry.id; })).size >= 2 && clock() - item.lastViewed <= item.days * DAY;
        }).sort(function (a, b) { return data.items[b].lastViewed - data.items[a].lastViewed; });
        if (handles[0]) v.choice = handles[0];
      }
      write(data);
      return v.choice && data.items[v.choice] ? Object.assign({ handle: v.choice }, data.items[v.choice]) : null;
    }
    /* Delete legacy unconsented scores; never migrate attempts into real interest. */
    LEGACY_KEYS.forEach(function (key) { safeRemove(storage, key); });
    return { clear: clear, read: read, view: view, selectVariant: selectVariant, candidate: candidate, currentVisit: currentVisit };
  }
  function selectAvailableVariant(product, preferredId) {
    if (!product || product.version !== VERSION || product.blocked || product.knownPurchased || !Array.isArray(product.variants)) return null;
    var variants = product.variants.filter(function (v) { return id(v.id) && v.eligible === true && Number.isFinite(v.price) && v.price > 0; });
    return variants.find(function (v) { return String(v.id) === String(preferredId); }) || variants[0] || null;
  }
  function cartResponseItems(ok, action, body) {
    if (!ok || !body || typeof body !== 'object') return [];
    var items = Array.isArray(body.items) ? body.items : action === 'add' ? [body] : [];
    return items.filter(function (item) { return item && id(item.variant_id || item.id) && id(item.product_id) && Number.isFinite(item.quantity) && item.quantity >= 0; }).map(function (item) {
      return { product_id: id(item.product_id), variant_id: id(item.variant_id || item.id), quantity_after: item.quantity };
    });
  }
  function cartAddedItems(ok, body) {
    if (!ok || !body || typeof body !== 'object') return [];
    return (Array.isArray(body.items) ? body.items : [body]).filter(function (item) { return item && id(item.variant_id || item.id) && id(item.product_id) && Number.isFinite(item.quantity) && item.quantity > 0; }).map(function (item) {
      return { product_id: id(item.product_id), variant_id: id(item.variant_id || item.id), id: id(item.variant_id || item.id), quantity: item.quantity, product_type: typeof item.product_type === 'string' ? item.product_type : '', handle: validHandle(item.handle) ? item.handle : null, title: typeof item.product_title === 'string' ? item.product_title : '' };
    });
  }
  function assignmentFor(experiment, storage, allowed, eligible, random, now) {
    /* Future experiment owner. No read/write/assignment while off or unverified. */
    if (!experiment || experiment.enabled !== true || experiment.destinationVerified !== true || !allowed || !eligible || !/^[A-Z0-9_-]{1,40}$/.test(experiment.id || '')) return null;
    var key = 'ema_experiment_' + experiment.id;
    try {
      var old = JSON.parse(storage.getItem(key));
      if (old && old.id === experiment.id && (old.arm === 'control' || old.arm === 'treatment')) return old;
      var next = { id: experiment.id, arm: random() < .5 ? 'control' : 'treatment', assigned_at: now };
      storage.setItem(key, JSON.stringify(next)); return next;
    } catch (_) { return null; }
  }
  function boot(win, doc) {
    if (win.EMAMerchandising) return;
    var configNode = doc.getElementById('ema-merchandising-config');
    if (!configNode) return;
    var config; try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    if (config.version !== VERSION) return;
    var debug = { version: VERSION, publish_calls: 0, publish_failures: 0, klaviyo_calls: 0, klaviyo_accepted: 0, klaviyo_skipped: 0, klaviyo_failures: 0, stock_checks: 0, module_rendered: false, destination_verified: false, experiments_enabled: false };
    var storage; var session;
    try { storage = win.localStorage; session = win.sessionStorage; } catch (_) { storage = session = { getItem: function () { return null; }, setItem: function () {}, removeItem: function () {} }; }
    var consent = { analytics: false, preferences: false, marketing: false };
    var started = false; var renderId; var productContextSent = false; var generation = 0;
    var cards = new Map(); var observer; var mutation; var timers = new Set();
    var rootUrl = typeof config.root === 'string' && config.root.charAt(0) === '/' ? config.root : '/';
    if (rootUrl.charAt(rootUrl.length - 1) !== '/') rootUrl += '/';
    function uuid() { return win.crypto && typeof win.crypto.randomUUID === 'function' ? win.crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2); }
    function preferencesAllowed() { return consent.preferences && consent.analytics; }
    var store = createStore(storage, String(config.scope || 'guest'), preferencesAllowed, Date.now, uuid);
    function analyticsAllowed() { return consent.analytics; }
    function klaviyoAllowed() { return consent.analytics && consent.marketing; }
    function forgetSession() { safeRemove(session, 'ema_list_context_v1'); }
    function clearAll() {
      store.clear(); forgetSession();
      /* Exp assignments cannot survive revocation. This v1 starts no experiments. */
      if (config.experiment && config.experiment.id) safeRemove(storage, 'ema_experiment_' + config.experiment.id);
      doc.querySelectorAll('[data-ema-recently-considered]').forEach(function (node) { node.hidden = true; var body = node.querySelector('[data-ema-recent-content]'); if (body) body.replaceChildren(); });
      debug.module_rendered = false; generation++;
    }
    function sortContext() {
      var params = new URLSearchParams(win.location.search);
      var sort = params.get('sort_by') || 'default';
      if (!/^(default|manual|best-selling|title-ascending|title-descending|price-ascending|price-descending|created-ascending|created-descending|relevance)$/.test(sort)) sort = 'other';
      return { sort: sort, filter_keys: Array.from(params.keys()).filter(function (key) { return key.indexOf('filter.') === 0; }).sort().slice(0, 20), page: Math.max(1, Math.min(10000, Number(params.get('page')) || 1)) };
    }
    function context(card) {
      var list = card.closest('[data-ema-placement]') || card.closest('ul') || card.closest('.shopify-section');
      var section = card.closest('.shopify-section');
      var siblings = list && list !== card ? Array.from(list.querySelectorAll('product-card[data-ema-product-id], [data-ema-card][data-ema-product-id]')) : [card];
      var filter = sortContext();
      return {
        product_id: id(card.dataset.emaProductId), variant_id: id(card.dataset.emaVariantId),
        placement: list && list.dataset.emaPlacement || section && section.id || 'product-list',
        collection_id: id(card.dataset.emaCollectionId || config.collectionId), rank: siblings.indexOf(card) + 1,
        stock_state: card.dataset.emaStock || 'unknown', rank_rule_version: card.dataset.emaRule || 'unchanged-order',
        sort: filter.sort, filter_keys: filter.filter_keys, page: filter.page
      };
    }
    function existingKlaviyoAvailable() { return !!(win.klaviyo && typeof win.klaviyo.track === 'function' && typeof win.klaviyo.isIdentified === 'function' && typeof win.klaviyo.account === 'function'); }
    function dispatchKlaviyo(name, payload) {
      if (config.klaviyoEventsEnabled !== true || !klaviyoAllowed() || !existingKlaviyoAvailable()) { debug.klaviyo_skipped++; return false; }
      var sdk = win.klaviyo;
      var names = { list_item_exposed: 'EMA | List item exposed', list_item_selected: 'EMA | List item selected', product_context: 'EMA | Product context', variant_selected: 'EMA | Variant selected', cart_response_confirmed: 'EMA | Cart response confirmed', decision_help_selected: 'EMA | Decision help selected' };
      if (!names[name]) return false;
      /* Existing browser identity only. Never identify, read email or backfill. */
      Promise.resolve().then(function () { if (!klaviyoAllowed()) return []; return Promise.all([sdk.account(), sdk.isIdentified()]); }).then(function (result) {
        if (result[0] !== config.klaviyoAccount || result[1] !== true || !klaviyoAllowed() || win.klaviyo !== sdk) { debug.klaviyo_skipped++; return; }
        debug.klaviyo_calls++;
        return Promise.resolve(sdk.track(names[name], Object.assign({}, payload, { coverage: 'consented_identified_browser', measurement_role: 'placement_diagnostic' }))).then(function (accepted) { if (accepted === true) debug.klaviyo_accepted++; else debug.klaviyo_failures++; });
      }).catch(function () { debug.klaviyo_failures++; });
      return true;
    }
    function publish(name, props, eventId) {
      if (!analyticsAllowed() || config.customEventsEnabled !== true) return false;
      var payload = Object.assign({ schema_version: 1, instrumentation_version: VERSION, event_id: eventId || uuid(), timestamp: new Date().toISOString(), page_render_id: renderId, page_type: config.pageType, consent_analytics: true, consent_preferences: consent.preferences }, props);
      /* No customer IDs, email, cart tokens, URLs/search strings or tank notes. */
      var routed = dispatchKlaviyo(name, payload);
      if (!win.Shopify || !win.Shopify.analytics || typeof win.Shopify.analytics.publish !== 'function') return routed;
      try {
        var result = win.Shopify.analytics.publish('ema:' + name, payload); debug.publish_calls++;
        if (result && typeof result.catch === 'function') result.catch(function () { debug.publish_failures++; });
        return true;
      } catch (_) { debug.publish_failures++; return routed; }
    }
    function cancelTimer(record) { if (record.timer) { win.clearTimeout(record.timer); timers.delete(record.timer); record.timer = null; } }
    function exposure(card, record) {
      cancelTimer(record);
      if (record.exposed || !analyticsAllowed() || doc.visibilityState === 'hidden' || !record.visible) return;
      record.timer = win.setTimeout(function () {
        timers.delete(record.timer); record.timer = null;
        if (!analyticsAllowed() || doc.visibilityState === 'hidden' || !record.visible || !card.isConnected) return;
        var current = context(card);
        if (current.product_id && current.rank > 0 && publish('list_item_exposed', current, renderId + ':exposure:' + record.number)) record.exposed = true;
      }, 1000);
      timers.add(record.timer);
    }
    function scan() {
      if (!observer) return;
      cards.forEach(function (record, card) { if (!card.isConnected) { cancelTimer(record); observer.unobserve(card); cards.delete(card); } });
      doc.querySelectorAll('product-card[data-ema-product-id], [data-ema-card][data-ema-product-id]').forEach(function (card) {
        if (cards.has(card)) return;
        cards.set(card, { number: uuid(), visible: false, exposed: false, timer: null }); observer.observe(card);
      });
    }
    function startObservers() {
      if (typeof win.IntersectionObserver === 'function') {
        observer = new win.IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { var record = cards.get(entry.target); if (!record) return; record.visible = entry.isIntersecting && entry.intersectionRatio >= .5; exposure(entry.target, record); });
        }, { threshold: [0, .5, 1] });
        scan();
        if (typeof win.MutationObserver === 'function') {
          mutation = new win.MutationObserver(scan); mutation.observe(doc.documentElement, { childList: true, subtree: true });
        }
      }
    }
    function productContext() {
      if (!config.product || productContextSent || !analyticsAllowed()) return;
      var preceding = null;
      if (preferencesAllowed()) try {
        var saved = JSON.parse(session.getItem('ema_list_context_v1'));
        if (saved && saved.context && saved.context.product_id === id(config.product.id) && Date.now() - saved.at < 20 * 60 * 1000) preceding = saved.context;
      } catch (_) {}
      productContextSent = publish('product_context', { product_id: id(config.product.id), variant_id: id(config.product.variantId), price_minor: config.product.price, currency: config.currency, available: config.product.available === true, preceding_list: preceding, fresh: true }, renderId + ':product');
    }
    function safePath(value) { return typeof value === 'string' && /^\/[^/]/.test(value) ? value : null; }
    function renderRecent(product, variant, target) {
      var url = safePath(product.url); if (!url) return;
      var path = url + '?variant=' + encodeURIComponent(String(variant.id));
      var article = doc.createElement('article'); article.className = 'ema-recent__card';
      article.dataset.emaCard = 'true'; article.dataset.emaProductId = String(product.id); article.dataset.emaVariantId = String(variant.id); article.dataset.emaStock = variant.stockState || 'unknown'; article.dataset.emaRule = 'recent-considered-stock-v1'; article.dataset.emaPlacement = 'home-recently-considered';
      var imageLink = doc.createElement('a'); imageLink.href = path;
      if (typeof product.image === 'string' && /^(https?:)?\/\//.test(product.image)) {
        var image = doc.createElement('img'); image.src = product.image; image.alt = product.title; image.width = 160; image.height = 160; image.loading = 'lazy'; image.className = 'ema-recent__image'; imageLink.appendChild(image);
      }
      var detail = doc.createElement('div'); var heading = doc.createElement('h3'); var titleLink = doc.createElement('a'); titleLink.href = path; titleLink.textContent = product.title; heading.appendChild(titleLink); detail.appendChild(heading);
      var price = doc.createElement('p');
      try { price.textContent = new Intl.NumberFormat('en-NZ', { style: 'currency', currency: config.currency || 'NZD' }).format(variant.price / 100); } catch (_) { price.textContent = (variant.price / 100).toFixed(2) + ' ' + (config.currency || 'NZD'); }
      if (variant.title && variant.title !== 'Default Title') price.textContent += ' · ' + variant.title;
      detail.appendChild(price);
      var available = doc.createElement('p'); available.textContent = 'Available option shown. Confirm care and delivery details on the product page.'; detail.appendChild(available);
      var links = doc.createElement('div'); links.className = 'ema-recent__links'; var view = doc.createElement('a'); view.href = path; view.textContent = 'View details'; links.appendChild(view);
      var help = doc.createElement('button'); help.type = 'button';
      help.textContent = typeof config.chatHelpLabel === 'string' && config.chatHelpLabel.trim() ? config.chatHelpLabel : 'Ask the reef assistant';
      help.dataset.emaChatHelp = ''; help.dataset.emaHelpTopic = 'fit-or-delivery';
      var helpProduct = product.title;
      if (variant.title && variant.title !== 'Default Title') helpProduct += ' (' + variant.title + ')';
      var helpQuestion = typeof config.chatHelpQuestion === 'string' && config.chatHelpQuestion.trim() ? config.chatHelpQuestion : 'Can you help me check whether [product] is right for my aquarium, and explain the delivery options?';
      help.dataset.emaChatQuestion = helpQuestion.replace('[product]', function () { return helpProduct; });
      help.setAttribute('aria-haspopup', 'dialog'); help.setAttribute('aria-controls', 'ema-chat-panel');
      /* EMA 2026-11-05: old chatbot help button no longer appended */ detail.appendChild(links);
      article.appendChild(imageLink); article.appendChild(detail);
      target.querySelector('[data-ema-recent-content]').replaceChildren(article); target.hidden = false; debug.module_rendered = true; scan();
    }
    async function refreshRecent() {
      if (!preferencesAllowed() || config.recentlyConsideredEnabled !== true) return;
      var target = doc.querySelector('[data-ema-recently-considered]'); if (!target) return;
      var candidate = store.candidate(); if (!candidate) return;
      var currentGeneration = ++generation;
      var url = new URL(rootUrl + 'products/' + candidate.handle, win.location.origin);
      url.searchParams.set('section_id', 'ema-merchandising-product');
      var preview = new URLSearchParams(win.location.search).get('preview_theme_id'); if (/^\d+$/.test(preview || '')) url.searchParams.set('preview_theme_id', preview);
      try {
        var basketResponse = await win.fetch(rootUrl + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!basketResponse.ok) return;
        var basket = await basketResponse.json();
        if (!Array.isArray(basket.items) || basket.items.some(function (item) { return id(item.product_id) === candidate.productId && item.quantity > 0; })) return;
        debug.stock_checks++;
        var response = await win.fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        var html = await response.text(); if (html.length > 150000) return;
        var parsed = new win.DOMParser().parseFromString(html, 'text/html');
        var node = parsed.querySelector('[data-ema-product-response]'); if (!node) return;
        var product = JSON.parse(node.textContent);
        if (!preferencesAllowed() || currentGeneration !== generation || product.handle !== candidate.handle || id(product.id) !== candidate.productId) return;
        var variant = selectAvailableVariant(product, candidate.variantId);
        if (variant) renderRecent(product, variant, target);
        else { target.hidden = true; debug.module_rendered = false; }
      } catch (_) { /* Keep the ordinary stock-led homepage when a check fails. */ }
    }
    function updateConsent() {
      var previous = { analytics: consent.analytics, preferences: consent.preferences };
      var privacy = win.Shopify && win.Shopify.customerPrivacy;
      try { consent.analytics = !!(privacy && typeof privacy.analyticsProcessingAllowed === 'function' && privacy.analyticsProcessingAllowed() === true); consent.preferences = !!(privacy && typeof privacy.preferencesProcessingAllowed === 'function' && privacy.preferencesProcessingAllowed() === true); consent.marketing = !!(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed() === true); } catch (_) { consent.analytics = consent.preferences = consent.marketing = false; }
      if (!preferencesAllowed()) clearAll();
      if (!consent.analytics) { cards.forEach(function (record) { cancelTimer(record); }); productContextSent = false; }
      if (preferencesAllowed() && (!previous.preferences || !previous.analytics)) { if (config.product) store.view(config.product); refreshRecent(); }
      if (consent.analytics) { productContext(); cards.forEach(function (record, card) { exposure(card, record); }); }
    }
    function start() {
      if (started) return; started = true; renderId = uuid();
      startObservers(); updateConsent();
      doc.addEventListener('visitorConsentCollected', updateConsent);
      doc.addEventListener('visibilitychange', function () {
        if (doc.visibilityState === 'hidden') cards.forEach(function (record) { cancelTimer(record); });
        else { updateConsent(); cards.forEach(function (record, card) { if (observer) { observer.unobserve(card); observer.observe(card); } }); refreshRecent(); }
      });
      win.addEventListener('pageshow', function (event) {
        if (!event.persisted) return;
        renderId = uuid(); productContextSent = false;
        cards.forEach(function (record, card) { cancelTimer(record); record.exposed = false; record.number = uuid(); if (observer) { observer.unobserve(card); observer.observe(card); } });
        updateConsent(); refreshRecent();
      });
      doc.addEventListener('click', function (event) {
        var target = event.target && event.target.closest ? event.target : null; if (!target) return;
        if (target.closest('[data-ema-forget]')) { clearAll(); return; }
        var card = target.closest('product-card[data-ema-product-id], [data-ema-card][data-ema-product-id]');
        var link = target.closest('a[href]');
        var help = target.closest('[data-ema-help-topic]');
        if (help) { publish('decision_help_selected', { topic: help.dataset.emaHelpTopic, product_id: card ? id(card.dataset.emaProductId) : null, variant_id: card ? id(card.dataset.emaVariantId) : null }); return; }
        if (!card || !link || !/\/products\//.test(link.getAttribute('href') || '') || !analyticsAllowed()) return;
        var data = context(card); if (!data.product_id) return;
        if (preferencesAllowed()) try { session.setItem('ema_list_context_v1', JSON.stringify({ context: data, at: Date.now() })); } catch (_) {}
        publish('list_item_selected', data);
      }, true);
      doc.addEventListener('change', function (event) {
        var card = event.target && event.target.closest ? event.target.closest('product-card[data-ema-product-id]') : null;
        if (card && event.target.matches('.opt-btn')) { publish('variant_selected', context(card)); return; }
        if (!config.product || !event.target || !event.target.matches || !event.target.matches('input[name="id"],select[name="id"]')) return;
        var variant = id(event.target.value); if (!variant) return;
        store.selectVariant(config.product, variant); publish('variant_selected', { product_id: id(config.product.id), variant_id: variant });
      });
      function cartAction(input) {
        try { var requestUrl = new URL(typeof input === 'string' ? input : input.url, win.location.href); var match = requestUrl.pathname.match(/\/cart\/(add|change|update|clear)(?:\.js)?$/); return requestUrl.origin === win.location.origin && match ? match[1] : null; } catch (_) { return null; }
      }
      function cartConfirmed(action, body) {
        if (action === 'add') {
          var added = cartAddedItems(true, body);
          /* Essential theme/cart coordination, no tracking/storage/identity. */
          if (added.length) doc.dispatchEvent(new win.CustomEvent('ema:cart-add-success', { detail: { items: added } }));
        }
        if (analyticsAllowed()) { var items = cartResponseItems(true, action, body); if (items.length || action === 'clear') publish('cart_response_confirmed', { action: action, actor: 'unclassified', items: items, measurement_role: 'diagnostic_context', native_commerce_event_owner: 'shopify' }); }
      }
      /* Successful same-origin Ajax cart responses only; never submissions/attempts. */
      if (typeof win.fetch === 'function') {
        var originalFetch = win.fetch;
        win.fetch = function (input, options) {
          var result = originalFetch.apply(this, arguments);
          var action = cartAction(input);
          if (!action) return result;
          return result.then(function (response) {
            if (response.ok && (action === 'add' || analyticsAllowed())) {
              try { response.clone().json().then(function (body) { cartConfirmed(action, body); }).catch(function () {}); } catch (_) {}
            }
            return response;
          });
        };
      }
      if (win.XMLHttpRequest && win.XMLHttpRequest.prototype) {
        var requests = new WeakMap(); var proto = win.XMLHttpRequest.prototype; var originalOpen = proto.open; var originalSend = proto.send;
        proto.open = function (method, url) { requests.set(this, { action: cartAction(url) }); return originalOpen.apply(this, arguments); };
        proto.send = function () {
          var xhr = this; var request = requests.get(xhr); var action = request && request.action;
          if (action) xhr.addEventListener('load', function () {
            if (requests.get(xhr) !== request) return;
            if (xhr.status < 200 || xhr.status >= 300 || (action !== 'add' && !analyticsAllowed())) return;
            try { var body = xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText); cartConfirmed(action, body); } catch (_) {}
          }, { once: true });
          return originalSend.apply(this, arguments);
        };
      }
    }
    win.EMAMerchandising = {
      status: function () { return Object.assign({}, debug, { analytics_allowed: consent.analytics, preferences_allowed: consent.preferences, marketing_allowed: consent.marketing, observed_cards: cards.size, publisher_available: !!(win.Shopify && win.Shopify.analytics && win.Shopify.analytics.publish), klaviyo_available: existingKlaviyoAvailable(), exposure_observer_available: !!observer }); },
      clear: clearAll,
      refreshStock: refreshRecent
    };
    if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true }); else start();
    if (win.Shopify && !win.Shopify.customerPrivacy && typeof win.Shopify.loadFeatures === 'function') win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) updateConsent(); });
    return win.EMAMerchandising;
  }
  return { version: VERSION, createStore: createStore, windowDays: windowDays, selectAvailableVariant: selectAvailableVariant, cartResponseItems: cartResponseItems, cartAddedItems: cartAddedItems, assignmentFor: assignmentFor, boot: boot };
});
